export const ENTRIES = [
{
name: "Megan Eggert",
email: "megan.eggert1@gmail.com",
golfers: [
	"Bryson DeChambeau",
	"Tommy Fleetwood",
	"Scottie Scheffler",
	"Matt Fitzpatrick",
	"Ludvig Åberg"
],
tiebreaker: -9
},
{
name: "George Eggert",
email: "george.eggert@gmail.com",
golfers: [
	"Scottie Scheffler",
	"Justin Rose",
	"Bryson DeChambeau",
	"Nicolai Højgaard",
	"Daniel Berger"
],
tiebreaker: -8
},
{
name: "Ray DelFava",
email: "rdelfava@sbcglobal.net",
golfers: [
	"Scottie Scheffler",
	"Tommy Fleetwood",
	"Akshay Bhatia",
	"Jon Rahm",
	"Cameron Young"
],
tiebreaker: -14
},
{
name: "Tom Arndt",
email: "tarndt1834@gmail.com",
golfers: [
	"Scottie Scheffler",
	"Rory McIlroy",
	"Hideki Matsuyama",
	"Justin Rose",
	"Akshay Bhatia"
],
tiebreaker: -16
},
{
name: "Roger VanWazer",
email: "rvanwazer@yahoo.com",
golfers: [
	"Xander Schauffele",
	"Jake Knapp",
	"Min Woo Lee",
	"Chris Gotterup",
	"Scottie Scheffler"
],
tiebreaker: -8
},
{
name: "Rob Lantz",
email: "lantzrj@aol.com",
golfers: [
	"Scottie Scheffler",
	"Bryson DeChambeau",
	"Rory McIlroy",
	"Justin Rose",
	"Xander Schauffele"
],
tiebreaker: -11
},
{
name: "Jeff Nelson",
email: "jeffnelsonemail@yahoo.com",
golfers: [
	"Scottie Scheffler",
	"Bryson DeChambeau",
	"Rory McIlroy",
	"Tommy Fleetwood",
	"Collin Morikawa"
],
tiebreaker: 0
},
{
name: "Patrick Emmelot 1",
email: "emmelotdvm@tds.net",
golfers: [
	"Scottie Scheffler",
	"Rory McIlroy",
	"Bryson DeChambeau",
	"Matt Fitzpatrick",
	"Ludvig Åberg"
],
tiebreaker: -11
},
{
name: "Patrick Emmelot 2",
email: "emmelotdvm@tds.net",
golfers: [
	"Bryson DeChambeau",
	"Rory McIlroy",
	"Justin Rose",
	"Tommy Fleetwood",
	"Jon Rahm"
],
tiebreaker: -11
},
{
name: "Tony Fasuna",
email: "tonyfasuna@gmail.com",
golfers: [
	"Bryson DeChambeau",
	"Jon Rahm",
	"Justin Rose",
	"Xander Schauffele",
	"Patrick Reed"
],
tiebreaker: -10
},
{
name: "Bob Churchill",
email: "rlchurchill@comcast.net",
golfers: [
	"Jon Rahm",
	"Brooks Koepka",
	"Tommy Fleetwood",
	"Justin Rose",
	"Bryson DeChambeau"
],
tiebreaker: -11
},
{
name: "Ron Fortman",
email: "forts21@aol.com",
golfers: [
	"Ludvig Åberg",
	"Jon Rahm",
	"Patrick Reed",
	"Xander Schauffele",
	"Min Woo Lee"
],
tiebreaker: -12
},
{
name: "Nick Morini",
email: "nick.morini@gmail.com",
golfers: [
	"Bryson DeChambeau",
	"Jon Rahm",
	"Patrick Reed",
	"Xander Schauffele",
	"Justin Rose"
],
tiebreaker: -10
},
{
name: "Al Shapiro",
email: "Ashapiro@hazchem.com",
golfers: [
	"Ludvig Åberg",
	"Matt Fitzpatrick",
	"Cameron Young",
	"Hideki Matsuyama",
	"Sepp Straka"
],
tiebreaker: -12
},
{
name: "Jeremy Simmons",
email: "jeremysimmons00@gmail.com",
golfers: [
	"Bryson DeChambeau",
	"Hideki Matsuyama",
	"Jon Rahm",
	"Cameron Young",
	"Patrick Reed"
],
tiebreaker: -19
},
{
name: "Dave Schlatter",
email: "daveschlatter.ds@gmail.com",
golfers: [
	"Matt Fitzpatrick",
	"Xander Schauffele",
	"Bryson DeChambeau",
	"Patrick Reed",
	"Scottie Scheffler"
],
tiebreaker: -9
},
{
name: "Patrick Colwell",
email: "colwellp3@gmail.com",
golfers: [
	"Bryson DeChambeau",
	"Scottie Scheffler",
	"Tommy Fleetwood",
	"Jon Rahm",
	"Min Woo Lee"
],
tiebreaker: -11
},
{
name: "Teddy Findlay",
email: "gretchenfindlay@gmail.com",
golfers: [
	"Bryson DeChambeau",
	"Jon Rahm",
	"Scottie Scheffler",
	"Xander Schauffele",
	"Justin Rose"
],
tiebreaker: -12
},
{
name: "Rob Wott",
email: "rwott711@gmail.com",
golfers: [
	"Scottie Scheffler",
	"Jon Rahm",
	"Bryson DeChambeau",
	"Rory McIlroy",
	"Xander Schauffele"
],
tiebreaker: -9
},
{
name: "Mike Smith",
email: "ahsmithfamily@gmail.com",
golfers: [
	"Rory McIlroy",
	"Scottie Scheffler",
	"Viktor Hovland",
	"Bryson DeChambeau",
	"Adam Scott"
],
tiebreaker: -12
},
{
name: "Phil Frawley",
email: "phifrawle@gmail.com",
golfers: [
	"Scottie Scheffler",
	"Jon Rahm",
	"Bryson DeChambeau",
	"Rory McIlroy",
	"Ludvig Åberg"
],
tiebreaker: -12
},
{
name: "Gary Klawans",
email: "gklawans@gmail.com",
golfers: [
	"Matt Fitzpatrick",
	"Jon Rahm",
	"Scottie Scheffler",
	"Jacob Bridgeman",
	"Cameron Young"
],
tiebreaker: -11
},
{
name: "Karl Stevens 1",
email: "karl.e.stevens@gmail.com",
golfers: [
	"Bryson DeChambeau",
	"Scottie Scheffler",
	"Xander Schauffele",
	"Ludvig Åberg",
	"Jon Rahm"
],
tiebreaker: -15
},
{
name: "Karl Stevens 2",
email: "karl.e.stevens@gmail.com",
golfers: [
	"Scottie Scheffler",
	"Tommy Fleetwood",
	"Robert MacIntyre",
	"Chris Gotterup",
	"Justin Rose"
],
tiebreaker: -14
},
{
name: "Robert Colwell",
email: "codfish76@aol.com",
golfers: [
	"Jon Rahm",
	"Patrick Reed",
	"Scottie Scheffler",
	"Xander Schauffele",
	"Rory McIlroy"
],
tiebreaker: -14
},
{
name: "Pete Majeski 1",
email: "jpmajeski@att.net",
golfers: [
	"Scottie Scheffler",
	"Matt Fitzpatrick",
	"Bryson DeChambeau",
	"Robert MacIntyre",
	"Tommy Fleetwood"
],
tiebreaker: -11
},
{
name: "Pete Majeski 2",
email: "jpmajeski@att.net",
golfers: [
	"Xander Schauffele",
	"Cameron Young",
	"Corey Conners",
	"Akshay Bhatia",
	"Cameron Smith"
],
tiebreaker: -13
},
{
name: "Brian Wade",
email: "brian_wade63@att.net",
golfers: [
	"Scottie Scheffler",
	"Cameron Young",
	"Ludvig Åberg",
	"Jon Rahm",
	"Collin Morikawa"
],
tiebreaker: -12
},
{
name: "Connie Wade",
email: "Cwade101997@att.net",
golfers: [
	"Scottie Scheffler",
	"Bryson DeChambeau",
	"Jon Rahm",
	"Ludvig Åberg",
	"Xander Schauffele"
],
tiebreaker: -10
},
{
name: "Marc Carmardo",
email: "cloutbb10@aol.com",
golfers: [
	"Scottie Scheffler",
	"Matt Fitzpatrick",
	"Cameron Young",
	"Chris Gotterup",
	"Rory McIlroy"
],
tiebreaker: -12
},
{
name: "David Hess",
email: "hessdavid22@gmail.com",
golfers: [
	"Scottie Scheffler",
	"Bryson DeChambeau",
	"Jon Rahm",
	"Ludvig Åberg",
	"Tommy Fleetwood"
],
tiebreaker: -12
},
{
name: "Mark Schmid",
email: "markarthurschmid@gmail.com",
golfers: [
	"Ludvig Åberg",
	"Matt Fitzpatrick",
	"Scottie Scheffler",
	"Hideki Matsuyama",
	"Rory McIlroy"
],
tiebreaker: -9
},
{
name: "Forrest Nelson",
email: "forrestnelsonjr@gmail.com",
golfers: [
	"Scottie Scheffler",
	"Tommy Fleetwood",
	"Ludvig Åberg",
	"Justin Rose",
	"Xander Schauffele"
],
tiebreaker: -7
},
{
name: "Danni Shapiro",
email: "dannisha@umich.edu",
golfers: [
	"Tommy Fleetwood",
	"Scottie Scheffler",
	"Ludvig Åberg",
	"Hideki Matsuyama",
	"Bryson DeChambeau"
],
tiebreaker: -12
},
]